module.exports = __webpack_public_path__ + "img/3.318e525f.png";